import {getImage} from '@dazn/lp-web/src/utils/commonUtils';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';
import {IComponent, IEntry, IVideoPlayer} from '../types';

export function videoPlayerProxy(component: IComponent): IVideoPlayer {
    const {componentType, title, description, entries} = component.fields || {};

    const filteredObj = (entries || []).reduce(
        (acc: Record<string, any>, entry: IEntry) => {
            const item: any = entry.fields;
            switch (entry?.sys?.contentType?.sys?.id) {
                case 'AdaptiveImage':
                    acc['thumbnail'] = getImage(entry);
                    break;
                case 'LPButton':
                    const btnData = buttonProxy(item);
                    acc['entitlementSetId'] = btnData?.entitlementSetId || '';
                    acc['button'] = btnData;
                    break;
                case 'CommonKeyValue':
                    acc[item.key] = item.value;
                    break;
                default:
                    break;
            }
            return acc;
        },
        {}
    );

    return {
        title,
        description,
        componentType,
        ...filteredObj
    };
}
